import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';
import { Wrapper, NewMenuItem } from './styled';

class Menu extends PureComponent {
    static propTypes = {
        className: PropTypes.string,
        items: PropTypes.array,
        activeItem: PropTypes.number,
    };

    constructor(props) {
        super(props);

        this.state = {
            activeItemIndex: 0
        };
    }

    render() {
        const { className, items } = this.props;
        const activeItem = Number(this.props.activeItem);

        return (
            <Wrapper className={className}>
                {items.map((item, idx) => {
                    const menuItem = (
                        <NewMenuItem active={activeItem === idx} onClick={item.action}>
                            <span>{item.text}</span>
                        </NewMenuItem>
                    );
                    return (
                        <Fragment key={idx}>
                            {item.route
                                ? <Link href={item.route} passHref>{menuItem}</Link>
                                : menuItem
                            }
                        </Fragment>
                    );
                })}
            </Wrapper>
        );
    }
}

export default Menu;
